import Chip from '@mui/material/Chip'
import Grow from '@mui/material/Grow'
import { alpha, useTheme } from '@mui/material/styles'
import Tooltip from '@mui/material/Tooltip'
import React from 'react'

import { isReactivationInProgress } from 'settings/constants/status'
import T from 'T'

type WorkOrdersCreatingChipProps = {
  since?: string | null
}

const TINT_OPACITY = 0.12

const WorkOrdersCreatingChip = ({ since }: WorkOrdersCreatingChipProps) => {
  const theme = useTheme()

  return (
    <Grow unmountOnExit in={isReactivationInProgress(since)}>
      <Tooltip arrow placement="bottom" title={T.ACCOUNT_REACTIVATION_CREATING_WORK_ORDERS_TOOLTIP}>
        <Chip
          label={T.ACCOUNT_REACTIVATION_CREATING_WORK_ORDERS}
          size="small"
          sx={{
            fontWeight: 600,
            borderColor: theme.palette.warning.main,
            backgroundColor: alpha(theme.palette.warning.main, TINT_OPACITY),
            color: theme.palette.warning.dark,
          }}
          variant="outlined"
        />
      </Tooltip>
    </Grow>
  )
}

export default WorkOrdersCreatingChip
